import { FormattedMessage } from 'react-intl'

import { DescriptionItem } from './description-item'

export const CryptoDescription = () => {
  return (
    <div className="flex flex-col gap-[14px]">
      <DescriptionItem
        color="action.active"
        text={<FormattedMessage id="edge.premiumRedeem.confirmCrypto.description.1" />}
      />
      <DescriptionItem
        color="warning.main"
        text={<FormattedMessage id="edge.premiumRedeem.confirmCrypto.description.2" />}
      />
      <DescriptionItem
        color="warning.main"
        text={<FormattedMessage id="edge.premiumRedeem.confirmCrypto.description.3" />}
      />
    </div>
  )
}
